import { t } from "i18next";
import { Headings, Paragraph } from "@sentara-health/optimahealth_web";

import {
  formatPersonName,
  toPascalCase,
} from "../../utils/helpers/TextFormaters";
import { ProfileFirstLetter } from "../../organisms/profile";

import { MenuAccordion } from "./";
import { useAuth, useBranding, Brands } from "providers";

/**
 * Sides menu
 * @returns
 */
export const SideMenu = () => {
  const { user } = useAuth();
  const { brandConfig } = useBranding();

  return (
    <div className="d-flex flex-column h-100">
      <div className="w-100">
        <div className="col-lg-12 col-md-12 col-sm-12 col-12">
          {brandConfig.brandName !== Brands.AVMED ? (
            <div
              className="heading-with-bg mb-3 mt-3"
              data-testid="txtProfileCardHeading"
            >
              <strong>{t("employerLink")}</strong>
            </div>
          ) : (
            <Paragraph
              className="heading-with-bg mb-3 mt-3"
              level={3}
              text={t("employerLink")}
              variant={"semiBold"}
              data-testid="txtProfileCardHeading"
            />
          )}
          <div className="d-flex flex-no-wrap align-items-center mb-3">
            <div className="profile-letter-wrapper">
              <ProfileFirstLetter
                firstName={toPascalCase(user?.person?.firstName ?? "")}
                lastName={toPascalCase(user?.person?.lastName ?? "")}
              />
            </div>
            <Headings
              className="flex-1 profile-name-text text-break ps-4 ms-3"
              level={5}
              text={formatPersonName(user?.person)}
              variant={brandConfig.brandName !== Brands.AVMED ? "extraBold" : "semiBold"}
              data-testid="txtUserFullName"
            />
          </div>
          <hr />

          {/* TODO: AVMED */}
          {user?.groups?.length ? (
            <div className="font-eighteen line-ht28 mb-3">
              <strong className="me-2" data-testid="lblServiceLabel">
                {user?.groups[0]?.groupName}
              </strong>
            </div>
          ) : undefined}

          <MenuAccordion id="acc_side_menu" />
        </div>
      </div>
    </div>
  );
};
